import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the mainLayout state domain
 */

const selectMainLayoutDomain = state => state.mainLayout || initialState;

/**
 * Other specific selectors
 */
const makeSelectLoading = () =>
  createSelector(
    selectMainLayoutDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectMainLayoutDomain,
    substate => substate.error,
    );

/**
 * Default selector used by MainLayout
 */

const makeSelectMainLayout = () =>
  createSelector(
    selectMainLayoutDomain,
    substate => substate,
  );

export {
  selectMainLayoutDomain,
  makeSelectMainLayout,
  makeSelectLoading,
  makeSelectError,
};
